import { createSelector } from "@reduxjs/toolkit";

import { nodeDesignsStateSelector } from "../managed/index.ts";
import { getNextId } from "../managed/nextIdOffset.ts";

export const getNextIdSelector = createSelector(
  nodeDesignsStateSelector,
  (nodeDesigns): GetNextId =>
    () =>
      getNextId(nodeDesigns.nextId),
);

export type GetNextId = () => number;
